import Cookie from 'js-cookie';

import { Config } from '@nw/shared/config';

import {
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY = 'n67h8d7rk7';
const COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY = 'n67h8d7erk';

export const getCollegePredictorAccessToken = () => {
  return getCookie(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY);
};

export const getCollegePredictorRefreshToken = () => {
  return getCookie(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY);
};

export const setCollegePredictorAccessTokenToDomain = (
  accessToken: string,
  expiryInDays = 30
) => {
  setCookie(
    COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY,
    accessToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
};

export const setCollegePredictorRefreshTokenToDomain = (
  refreshToken: string,
  expiryInDays = 30
) => {
  setCookie(
    COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY,
    refreshToken,
    expiryInDays,
    Config['APP_AUTH_COOKIE_DOMAIN']
  );
};

export const clearCollegePredictorAccessToken = () => {
  Cookie.remove(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY, {
    path: '/',
    secure: true,
    sameSite: 'None'
  });
};

const clearCollegePredictorDomainAccessToken = (domain?: string) => {
  Cookie.remove(COLLEGE_PREDICTOR_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

const clearCollegePredictorDomainRefreshAccessToken = (domain?: string) => {
  Cookie.remove(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearCollegePredictorDomainTokens = () => {
  if (Config['APP_AUTH_COOKIE_DOMAIN']) {
    clearCollegePredictorDomainAccessToken(Config['APP_AUTH_COOKIE_DOMAIN']);
    clearCollegePredictorDomainRefreshAccessToken(
      Config['APP_AUTH_COOKIE_DOMAIN']
    );
  }
};

export const clearCollegePredictorRefreshAccessToken = () => {
  Cookie.remove(COLLEGE_PREDICTOR_REFRESH_TOKEN_KEY, {
    path: '/',
    secure: true,
    sameSite: 'None'
  });
};
